import { PrecedentMapControlsView } from "./views/precedent-map-controls";
import { PrecedentMapView } from "./views/precedent-map";
import { PrecedentMapModel } from "./models/precedent-map";
import { PrecedentMapControlsModel } from "./models/precedent-map-controls";
import { TemplateManager } from "../shared/helpers/template-manager";
import { autoinject, Container } from "aurelia-dependency-injection";
import { MasterView } from "../shared/views/master-view";
import { AppEvents } from "../app-events";
import { AuthService } from "../authentication/auth-service";
import { AppUser } from "../authentication/app-user";

require("./styles/precedent-map.less");

@autoinject
export class PrecedentMapModule extends Backbone.Model {
    private controlsRegion: Marionette.Region;
    private pMap: any;
    private surface: any;
    private activePrecedentMap: PrecedentMapView;
    private exitUrl: string;
    private ready = false;
    private user: AppUser;

    constructor(private authService: AuthService, private masterView: MasterView, public events: Backbone.Events, public controlsView: PrecedentMapControlsView, public controlsModel: PrecedentMapControlsModel, public templateManager: TemplateManager, public appEvents: Backbone.Events) {
        super();
        this.user = authService.AppUser;
        this.setupEvents();
    }

    public setupMap() {
        return new Promise<any>((resolve, reject) => {
          if (this.ready) {
            this.surface.attr("width", $("#precedent-map-region").width());
            this.surface.attr("height", $("#precedent-map-region").height());
            resolve();
         } else {
            const pMapTemplate = this.templateManager.getTemplate("PrecedentMap");
            pMapTemplate.then((template) => {
                const rendered = (Backbone as any).Marionette.Renderer.render(template.Raw, {});
                $("#precedent-map-region").html(rendered);
                _.defer(() => {
                    this.controlsRegion = this.masterView.addRegion("precedentMapControlsRegion", "#precedent-map-controls-region");
                    this.controlsRegion.show(this.controlsView);
                    this.surface = Snap("#precedent-map");
                    this.surface.attr("width", $("#precedent-map-region").width());
                    this.surface.attr("height", $("#precedent-map-region").height());
                    this.ready = true;
                    resolve();
                });
            });
         }
        });
    }

    public hide() {
        if (this.controlsModel) {
            this.controlsModel.set("Engaged", false);
            $("body").removeClass("precedent-map");
            $("#precedent-map-region").hide();

            if (this.activePrecedentMap) {
                this.activePrecedentMap.clean();
            }
        }
    }

    public enterPrecedentMap(id, unique, fromHistory) {

        $("#precedent-map-title").fadeOut("fast");
        $("#precedent-map-options-extra-cases").fadeOut("fast");

        this.controlsModel.set("Engaged", true);

        $("#precedent-map-region").show();

        if (this.user.Sku !== "pro") {
            $(".precedent-map-promo-content").show();
            $("#precedent-map-options").hide();
        } else {
            $(".precedent-map-promo-content").hide();
            $("#precedent-map-options").show();
        }

        let origin;
        if (this.activePrecedentMap) {
            origin = this.activePrecedentMap.origin;
            this.activePrecedentMap.disappear();
        }
        const model = Container.instance.get(PrecedentMapModel);
        model.DocKey = id;
        model.UniqueId = unique;

        // This defer is here because in firefox, even through this.surface has a value, it comes out as null in the called view
        // But when you put a breakpoint in the contructor of tha Views.PrecedentMap, all is good.  Seems to be a timing issue
        // So the defer seems to have fixed the issue.  Not great but it works. Rak
        _.defer(() => {
            this.activePrecedentMap =  Container.instance.get(PrecedentMapView);
            this.activePrecedentMap.init(id, unique, this.surface);
            // only go and create a real precedent map if they're a pro user
            if (this.user.Sku === "pro") {
                this.activePrecedentMap.create(origin);
            }
        });

        this.controlsModel.logChange(model, fromHistory);
    }

    public exitPrecedentMapToDocument() {
        this.controlsModel.set("Engaged", false);
        $(".precedent-map-promo-content").hide();
        $("#precedent-map-options").hide();

        if (this.activePrecedentMap) {
            this.activePrecedentMap.disappear();
        }
        this.controlsModel.resetHistory();
        this.controlsModel.unset("ExitUrl");
        this.controlsRegion = null;
    }

    public setExitPoint(name: string, id: string) {
        const existing = this.controlsModel.ExitUrl;
        const url = existing ? existing : this.createExitUrl(name, id);
        this.controlsModel.ExitUrl = url;
    }

    private setupEvents() {
        this.events.on(AppEvents.PrecedentMapDisplayTypesChanged, (params) => {
            if (!this.activePrecedentMap) {
                return;
            }
            this.activePrecedentMap.model.setDisplayRelations(params.relationTypes);
            this.activePrecedentMap.model.trigger("redraw", params.animate); // second param is animation
        });
        this.events.on(AppEvents.PrecedentMapLoaded, (model) => {
            this.updateControls(model);
            this.setDisplayRelations(model);
        });
    }

    private setupViews() {
        this.listenToOnce(this.masterView, "render", () => {
            const region = this.masterView.addRegion("precedentMapRegion", "#precedent-map-region");
        });
    }

    private setDisplayRelations(model: PrecedentMapModel) {
        if (model.TotalNodesCount > 30) {
            this.controlsModel.setDisplayTypes([1, 3], true);
        } else {
            this.controlsModel.setDisplayTypes([1, 2, 3], true);
        }
    }

    private updateControls(model) {
        this.setTitle(model);
        if (model.TotalNodesCount - model.FilteredNodesCount > 0) {
            this.setNodesMessage(model);
        }
    }

    private setTitle(model) {
        const $title = $("#precedent-map-title");
        $title.find("span").text(`${model.Title} ${model.Year}`);
        $title.fadeIn();
        $title.click(() => {
            const mod = this.activePrecedentMap.model;
            const url = `case/${mod.FriendlyUrlTitle}/overview/${mod.DocKey}`;
            Backbone.history.navigate(url, true);
        });
        document.title = `${model.Title} on JustisOne`;
    }

    private setNodesMessage(model) {
        const $message = $("#precedent-map-options-extra-cases");
        if (model.TotalNodesCount - model.FilteredNodesCount === 1) {
            $message.find("label").text(`There is 1 extra case outside your jurisdiction settings. Click here to show it.`);
        } else {
            $message.find("label").text(`There are ${model.TotalNodesCount - model.FilteredNodesCount} extra cases outside your jurisdiction settings. Click here to show them.`);
        }
        $message.fadeIn();
        $message.unbind().on("click", () => {
            $message.hide();
            this.activePrecedentMap.clean();
            this.activePrecedentMap.drawLoader();
            model.ShowAllJurisdictions = true;
            model.loadData().then(() => {
                this.activePrecedentMap.thinking.empty();
                this.setDisplayRelations(model);
                this.setNodesMessageUserJurisdictions(model);
            });
        });
    }

    private setNodesMessageUserJurisdictions(model) {
        const $nodeMessage = $("#precedent-map-options-extra-cases");
        $nodeMessage.find("label").text(`Click here to show cases based on your jurisdiction settings.`);
        $nodeMessage.fadeIn();
        $nodeMessage.unbind().on("click", () => {
            $nodeMessage.hide();
            this.activePrecedentMap.clean();
            this.activePrecedentMap.drawLoader();
            model.ShowAllJurisdictions = false;
            model.loadData().then(() => {
                this.activePrecedentMap.thinking.empty();
                this.setDisplayRelations(model);
                this.setNodesMessage(model);
            });
        });
    }

    private createExitUrl(name, id) {
        const fulltextModeSection = $(".analysis-nav li").filter(".active").find("a").attr("data-section");
        return `case/${name}/${fulltextModeSection}/${id}`;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/precedent-map/precedent-map-module.ts